// extracted by mini-css-extract-plugin
export default {"title":"ProductionTablet_title__RwHN9","item":"ProductionTablet_item__S2pGc","item__title":"ProductionTablet_item__title__2AveW","item__descr":"ProductionTablet_item__descr__pYjYp"};